module.exports = __webpack_public_path__ + "static/media/bk-download_phone.db0bec09.png";